module.exports = __webpack_public_path__ + "img/3.9c712d5f.webp";